<template>
  <div class="image-video">
    <image-video-component
      :alt="alt"
      :caption="caption"
      :image="image"
      :video-url="videoUrl"
      :sizes="dimensions"
      :use-picture="true"
      :auto-quality="'best'"
    />
  </div>
</template>

<script>

export default {
  name: "ImageVideoBlock",
  props: {
    alt: {
      type: String,
      default: 'Film från youtube, saknar beskrivning'
    },
    caption: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => {}
    },
    videoUrl: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          width: 734
        },
        medium: {
          width: 799
        },
        large: {
          width: 821
        }
      },
    }
  }
}
</script>

<style lang="scss">
.image-video {
  & .image-video-wrapper {
    margin: 0 0.5rem 2.5rem;

    @include media-breakpoint-up(md) {
      margin: 0 0 2.5rem;
      padding: 0;
    }

    @include media-breakpoint-up(lg) {
      padding: 0;
    }

    @include media-breakpoint-up(xl) {
      padding: 0;
    }
  }
}
</style>
